// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Button, Typography, Grid } from "@mui/material";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
// import AddUserIcon from "../../../../Assets/Icons/add-user-icon.png";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import httpclient from "../../../../Utils";
// import { createFilterHandler } from "../../../../Utils/FilterUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { useBranch } from "../../../../Hooks/useBranch";
// import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

// import { getColumns } from "./columns";
// import Filter from "./Filter";
// import ConfirmationModal from "./ConfirmationModal";
// import DriverDetailsModal from "./DriverDetailsModal";

// const INITIAL_FILTER_STATE = {
//   driverName: "",
//   active: "",
//   branch: null,
//   userName: "",
// };

// const fieldMappings = {
//   driverName: ["full_name", "$contains"],
//   active: ["status", "$eq"],
//   branch: ["branch", "$contains"],
//   userName: ["user_name", "$contains"],
// };

// const valueTransformers = {
//   active: (value) => {
//     if (value === "Active") return 1;
//     if (value === "Inactive") return 0;
//     return value;
//   },
//   branch: (value) => {
//     if (typeof value === "object") {
//       return value?.branch_code || value;
//     }
//     return value;
//   },
// };

// export default function DriversTable() {
//   const navigate = useNavigate();

//   const [drivers, setDrivers] = useState([]);
//   const [selectedDriver, setSelectedDriver] = useState(null);
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
//   const [submittedData, setSubmittedData] = useState({});
//   const [open, setOpen] = useState(false);
//   const [openDeleteDriver, setOpenDeleteDriver] = useState(false);
//   const [openViewDetails, setOpenViewDetails] = useState(false);
//   const [selectedDriverForView, setSelectedDriverForView] = useState(null);
//   const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
// const [allowAdd, setAllowAdd] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [rowCount, setRowCount] = useState(0);
//   const [sortModel, setSortModel] = useState([]);
//   const [refreshList, setRefreshList] = useState(false);

//   const { currentBranch } = useBranch();
//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();

//   const fetchDrivers = async (
//     page = 1,
//     pageSize = 20,
//     filters = submittedData,
//     sortInfo = sortModel
//   ) => {
//     setLoading(true);

//     const endpoint = `delivery/drivers`;

//     const apiUrl = buildApiQuery(endpoint, {
//       page: paginationModel.page + 1,
//       pageSize: paginationModel.pageSize,
//       filters: submittedData,
//       sortModel,
//       fieldMappings,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;
//       console.log("response check",res)
//       if (data.status === 200) {
//         setDrivers(data.data);
//         setRowCount(data.meta?.total || data.count || 0);
//          if (data.allow_add !== undefined) {
//           setAllowAdd(data.allow_add);
//         }
//         setRefreshList(false);
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDrivers(
//       paginationModel.page + 1,
//       paginationModel.pageSize,
//       submittedData,
//       sortModel
//     );
//   }, [
//     refreshList,
//     currentBranch,
//     paginationModel.page,
//     paginationModel.pageSize,
//     sortModel,
//     submittedData,
//   ]);

//   const handleChangeFilter = (field) => (event, value) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [field]: value || (event && event.target.value) || "",
//     }));
//   };
//  const handleClearOrder = async () => {
//     setActionLoading(true);

//     const API_URL = `delivery/${selectedUser.id}/clear-invoices`;

//     try {
//       const { data } = await httpclient.post(API_URL);

//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedUser("");
//         setOpen(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         setTimeout(() => {
//           setOpen(false); // Close modal
//         }, 1000);
//       } else if (error.response?.status === 401) {
//         refresh();
//       }

//       handleApiError(error);
//     } finally {
//       setActionLoading(false);
//     }
//   };
//   const handleFilter = createFilterHandler({
//     setLoading,
//     setSubmittedData,
//     setResults: setDrivers,
//     showNotification,
//     handleApiError,
//     httpClient: httpclient,
//     endpoint: `delivery/drivers`,
//     fieldMappings,
//     valueTransformers,
//     refresh,
//   });

//   const onFilterClick = () => {
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     handleFilter(filterData);
//   };

//   const handleRemove = (field) => {
//     const newFilterData = { ...filterData };
//     const newSubmittedData = { ...submittedData };

//     newFilterData[field] = field === "branch" ? null : "";
//     delete newSubmittedData[field];

//     setFilterData(newFilterData);
//     setSubmittedData(newSubmittedData);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));

//     handleFilter(newFilterData);
//   };

//   const handleClearFilters = () => {
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleAddDriver = () => {
//     navigate("/delivery/drivers/add");
//   };

//   const handleEdit = (driver) => {
//     setSelectedDriver(driver);
//     navigate(`/delivery/drivers/edit/${driver.id}`);
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleDeleteDriver = async () => {
//     setActionLoading(true);
//     const API_URL = `delivery/drivers/delete/${selectedDriver.id}`;
//     try {
//       const { data } = await httpclient.post(API_URL);
//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedDriver(null);
//         setOpenDeleteDriver(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         showNotification("error", "Driver not found");
//         setTimeout(() => {
//           setRefreshList(true);
//         }, 1000);
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleStatusChange = async () => {
//     setActionLoading(true);
//     const API_URL = `delivery/drivers/change-status/${selectedDriver.id}`;
//     try {
//       const { data } = await httpclient.post(API_URL);
//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedDriver(null);
//         setOpenStatusChangeModal(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         showNotification("error", "Driver not found");
//         setTimeout(() => {
//           setRefreshList(true);
//         }, 1000);
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const columns = getColumns(
//     handleEdit,
//     setOpenDeleteDriver,
//     setSelectedDriver,
//     setOpenViewDetails,
//     setSelectedDriverForView,
//     setOpenStatusChangeModal
//   );
// const clearOrdersMessage = (
//     <>
//       Are you sure you want to clear all orders for user:{" "}
//       <strong>{selectedUser?.full_name}</strong>
//     </>
//   );
//   const deleteDriverMessage = (
//     <>
//       Are you sure you want to delete driver:{" "}
//       <strong>{selectedDriver?.full_name}</strong>
//     </>
//   );

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "24px 16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Drivers
//             </Typography>
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             md={6}
//             display="flex"
//             alignItems="center"
//             justifyContent="flex-end"
//             gap={2}
//           >

//             {
//               allowAdd===1 && (
//             <Button
//               variant="contained"
//               sx={{
//                 borderRadius: "4px",
//                 backgroundColor: "#7152F3",
//                 "&:hover": {
//                   backgroundColor: "#5c34fa",
//                 },
//               }}
//               startIcon={<img src={AddUserIcon} alt="Add Driver" />}
//               onClick={handleAddDriver}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontSize: "14px",
//                   fontWeight: 500,
//                   textTransform: "none",
//                 }}
//               >
//                 Add New Driver
//               </Typography>
//             </Button>
//             )
//             }
//             <img
//               src={filterOpen ? FilterBtnUp : FilterBtn}
//               alt="Filter"
//               style={{ cursor: "pointer" }}
//               onClick={() => setFilterOpen(!filterOpen)}
//             />
//           </Grid>
//           <Filter
//             filterOpen={filterOpen}
//             filterData={filterData}
//             handleChangeFilter={handleChangeFilter}
//             handleFilter={onFilterClick}
//             handleClearFilters={handleClearFilters}
//             handleRemove={handleRemove}
//             submittedData={submittedData}
//           />
//         </Grid>

//         <DataGrid
//           rows={drivers || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           initialState={{
//             pagination: { paginationModel: { pageSize: 20 } },
//           }}
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel}
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />
//  {open && (
//           <ConfirmationModal
//             open={open}
//             handleClose={() => setOpen(false)}
//             title={"Clear Orders"}
//             message={clearOrdersMessage}
//             selectedUser={selectedUser}
//             onConfirm={handleClearOrder}
//             actionLoadingText="Clearing..."
//             ActionBtnText="Clear"
//             loading={actionLoading}
//           />
//         )}
//         {openDeleteDriver && (
//           <ConfirmationModal
//             open={openDeleteDriver}
//             handleClose={() => setOpenDeleteDriver(false)}
//             title={"Delete Driver"}
//             message={deleteDriverMessage}
//             selectedDriver={selectedDriver}
//             onConfirm={handleDeleteDriver}
//             actionLoadingText="Deleting..."
//             ActionBtnText="Delete"
//             loading={actionLoading}
//           />
//         )}

//         {openViewDetails && (
//           <DriverDetailsModal
//             open={openViewDetails}
//             onClose={() => setOpenViewDetails(false)}
//             driverId={selectedDriverForView?.id}
//           />
//         )}

//         {openStatusChangeModal && (
//           <ConfirmationModal
//             open={openStatusChangeModal}
//             handleClose={() => setOpenStatusChangeModal(false)}
//             title={"Change Driver Status"}
//             message={
//               <>
//                 Are you sure you want to change the status of driver:{" "}
//                 <strong>{selectedDriver?.full_name}</strong> to{" "}
//                 <strong>
//                   {selectedDriver?.status === 1 ? "Inactive" : "Active"}
//                 </strong>
//                 ?
//               </>
//             }
//             selectedDriver={selectedDriver}
//             onConfirm={handleStatusChange}
//             actionLoadingText="Changing..."
//             ActionBtnText="Change Status"
//             loading={actionLoading}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// }

// *********************************************************************************************************************

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Button, Typography, Grid } from "@mui/material";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
// import AddUserIcon from "../../../../Assets/Icons/add-user-icon.png";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import httpclient from "../../../../Utils";
// import { createFilterHandler } from "../../../../Utils/FilterUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { useBranch } from "../../../../Hooks/useBranch";
// import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

// import { getColumns } from "./columns";
// import Filter from "./Filter";
// import ConfirmationModal from "./ConfirmationModal";
// import DriverDetailsModal from "./DriverDetailsModal";

// const INITIAL_FILTER_STATE = {
//   driverName: "",
//   active: "",
//   branch: null,
//   userName: "",
// };

// const fieldMappings = {
//   driverName: ["full_name", "$contains"],
//   active: ["status", "$eq"],
//   branch: ["branch", "$contains"],
//   userName: ["user_name", "$contains"],
// };

// const valueTransformers = {
//   active: (value) => {
//     if (value === "Active") return 1;
//     if (value === "Inactive") return 0;
//     return value;
//   },
//   branch: (value) => {
//     if (typeof value === "object") {
//       return value?.branch_code || value;
//     }
//     return value;
//   },
// };

// export default function DriversTable() {
//   const navigate = useNavigate();

//   const [drivers, setDrivers] = useState([]);
//   const [selectedDriver, setSelectedDriver] = useState(null);
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
//   const [submittedData, setSubmittedData] = useState({});
//   const [openDeleteDriver, setOpenDeleteDriver] = useState(false);
//   const [openViewDetails, setOpenViewDetails] = useState(false);
//   const [selectedDriverForView, setSelectedDriverForView] = useState(null);
//   const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
  
//   // Add states for assign and clear orders
//   const [openAssignOrders, setOpenAssignOrders] = useState(false);
//   const [openClearOrders, setOpenClearOrders] = useState(false);
//   const [selectedDriverForAssignOrders, setSelectedDriverForAssignOrders] = useState(null);
//   const [selectedDriverForClearOrders, setSelectedDriverForClearOrders] = useState(null);
  
//   const [allowAdd, setAllowAdd] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [rowCount, setRowCount] = useState(0);
//   const [sortModel, setSortModel] = useState([]);
//   const [refreshList, setRefreshList] = useState(false);

//   const { currentBranch } = useBranch();
//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();

//   const fetchDrivers = async () => {
//     setLoading(true);

//     const endpoint = `delivery/drivers`;

//     const apiUrl = buildApiQuery(endpoint, {
//       page: paginationModel.page + 1,
//       pageSize: paginationModel.pageSize,
//       filters: submittedData,
//       sortModel,
//       fieldMappings,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;
//       console.log("response check", res);
//       if (data.status === 200) {
//         setDrivers(data.data);
//         setRowCount(data.meta?.total || data.count || 0);
//         if (data.allow_add !== undefined) {
//           setAllowAdd(data.allow_add);
//         }
//         setRefreshList(false);
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDrivers();
//   }, [
//     refreshList,
//     currentBranch,
//     paginationModel.page,
//     paginationModel.pageSize,
//     sortModel,
//     submittedData,
//   ]);

//   const handleChangeFilter = (field) => (event, value) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [field]: value || (event && event.target.value) || "",
//     }));
//   };

//   // Clear Orders handler
//   const handleClearOrders = async () => {
//     setActionLoading(true);

//     const API_URL = `delivery/clear-invoices/${selectedDriverForClearOrders?.id}`;

//     try {
//       const { data } = await httpclient.post(API_URL);

//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedDriverForClearOrders(null);
//         setOpenClearOrders(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         showNotification("error", "Driver not found");
//         setTimeout(() => {
//           setOpenClearOrders(false);
//         }, 1000);
//       } else if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   // Assign Orders handler
//   const handleAssignOrders = async () => {
//     setActionLoading(true);

//     const API_URL = `delivery/drivers/assign-orders/${selectedDriverForAssignOrders?.id}`;

//     try {
//       const { data } = await httpclient.post(API_URL);

//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedDriverForAssignOrders(null);
//         setOpenAssignOrders(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         showNotification("error", "Driver not found");
//         setTimeout(() => {
//           setOpenAssignOrders(false);
//         }, 1000);
//       } else if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleFilter = createFilterHandler({
//     setLoading,
//     setSubmittedData,
//     setResults: setDrivers,
//     showNotification,
//     handleApiError,
//     httpClient: httpclient,
//     endpoint: `delivery/drivers`,
//     fieldMappings,
//     valueTransformers,
//     refresh,
//   });

//   const onFilterClick = () => {
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     handleFilter(filterData);
//   };

//   const handleRemove = (field) => {
//     const newFilterData = { ...filterData };
//     const newSubmittedData = { ...submittedData };

//     newFilterData[field] = field === "branch" ? null : "";
//     delete newSubmittedData[field];

//     setFilterData(newFilterData);
//     setSubmittedData(newSubmittedData);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));

//     handleFilter(newFilterData);
//   };

//   const handleClearFilters = () => {
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleAddDriver = () => {
//     navigate("/delivery/drivers/add");
//   };

//   const handleEdit = (driver) => {
//     setSelectedDriver(driver);
//     navigate(`/delivery/drivers/edit/${driver.id}`);
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleDeleteDriver = async () => {
//     setActionLoading(true);
//     const API_URL = `delivery/drivers/delete/${selectedDriver.id}`;
//     try {
//       const { data } = await httpclient.post(API_URL);
//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedDriver(null);
//         setOpenDeleteDriver(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         showNotification("error", "Driver not found");
//         setTimeout(() => {
//           setRefreshList(true);
//         }, 1000);
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleStatusChange = async () => {
//     setActionLoading(true);
//     const API_URL = `delivery/drivers/change-status/${selectedDriver.id}`;
//     try {
//       const { data } = await httpclient.post(API_URL);
//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedDriver(null);
//         setOpenStatusChangeModal(false);
//         setRefreshList(true);
//       } else {
//         showNotification("info", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 404) {
//         showNotification("error", "Driver not found");
//         setTimeout(() => {
//           setRefreshList(true);
//         }, 1000);
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setActionLoading(false);
//     }
//   };

// const columns = getColumns(
//   handleEdit,
//   setOpenDeleteDriver,
//   setSelectedDriver,
//   setOpenViewDetails,
//   setSelectedDriverForView,
//   setOpenStatusChangeModal,
//   setOpenAssignOrders,
//   setSelectedDriverForAssignOrders,
//   setOpenClearOrders,
//   setSelectedDriverForClearOrders,
//   () => setRefreshList(true),
//   drivers // Pass the drivers array here
// );
//   const deleteDriverMessage = (
//     <>
//       Are you sure you want to delete driver:{" "}
//       <strong>{selectedDriver?.full_name}</strong>
//     </>
//   );

//   const assignOrdersMessage = (
//     <>
//       Are you sure you want to assign orders to driver:{" "}
//       <strong>{selectedDriverForAssignOrders?.full_name}</strong>?
//     </>
//   );
// const clearOrdersMessage = (
//   <>
//     Are you sure you want to release all assigned invoices for driver:{" "}
//     <strong>{selectedDriverForClearOrders?.full_name}</strong>?
//   </>
// );
//   // const clearOrdersMessage = (
//   //   <>
//   //     Are you sure you want to clear all assigned invoices for driver:{" "}
//   //     <strong>{selectedDriverForClearOrders?.full_name}</strong>
//   //   </>
//   // );

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "24px 16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Drivers
//             </Typography>
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             md={6}
//             display="flex"
//             alignItems="center"
//             justifyContent="flex-end"
//             gap={2}
//           >
//             {allowAdd === 1 && (
//               <Button
//                 variant="contained"
//                 sx={{
//                   borderRadius: "4px",
//                   backgroundColor: "#7152F3",
//                   "&:hover": {
//                     backgroundColor: "#5c34fa",
//                   },
//                 }}
//                 startIcon={<img src={AddUserIcon} alt="Add Driver" />}
//                 onClick={handleAddDriver}
//               >
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     fontSize: "14px",
//                     fontWeight: 500,
//                     textTransform: "none",
//                   }}
//                 >
//                   Add New Driver
//                 </Typography>
//               </Button>
//             )}
//             <img
//               src={filterOpen ? FilterBtnUp : FilterBtn}
//               alt="Filter"
//               style={{ cursor: "pointer" }}
//               onClick={() => setFilterOpen(!filterOpen)}
//             />
//           </Grid>
//           <Filter
//             filterOpen={filterOpen}
//             filterData={filterData}
//             handleChangeFilter={handleChangeFilter}
//             handleFilter={onFilterClick}
//             handleClearFilters={handleClearFilters}
//             handleRemove={handleRemove}
//             submittedData={submittedData}
//           />
//         </Grid>

//         <DataGrid
//           rows={drivers || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           initialState={{
//             pagination: { paginationModel: { pageSize: 20 } },
//           }}
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel}
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />

//         {/* Clear Orders Modal - using selectedDriver prop */}
//         {openClearOrders && (
//           <ConfirmationModal
//             open={openClearOrders}
//             handleClose={() => setOpenClearOrders(false)}
//             title={"Clear Invoice"}
//             message={clearOrdersMessage}
//             selectedDriver={selectedDriverForClearOrders}
//             onConfirm={handleClearOrders}
//             actionLoadingText="Releasing..."
//             ActionBtnText="Release Invoices"
//             loading={actionLoading}
//           />
//         )}

//         {/* Assign Orders Modal - you can create a separate modal or use ConfirmationModal */}
//         {openAssignOrders && (
//           <ConfirmationModal
//             open={openAssignOrders}
//             handleClose={() => setOpenAssignOrders(false)}
//             title={"Assign Orders"}
//             message={assignOrdersMessage}
//             selectedDriver={selectedDriverForAssignOrders}
//             onConfirm={handleAssignOrders}
//             actionLoadingText="Assigning..."
//             ActionBtnText="Assign Orders"
//             loading={actionLoading}
//           />
//         )}

//         {openDeleteDriver && (
//           <ConfirmationModal
//             open={openDeleteDriver}
//             handleClose={() => setOpenDeleteDriver(false)}
//             title={"Delete Driver"}
//             message={deleteDriverMessage}
//             selectedDriver={selectedDriver}
//             onConfirm={handleDeleteDriver}
//             actionLoadingText="Deleting..."
//             ActionBtnText="Delete"
//             loading={actionLoading}
//           />
//         )}

//         {openViewDetails && (
//           <DriverDetailsModal
//             open={openViewDetails}
//             onClose={() => setOpenViewDetails(false)}
//             driverId={selectedDriverForView?.id}
//           />
//         )}

//         {openStatusChangeModal && (
//           <ConfirmationModal
//             open={openStatusChangeModal}
//             handleClose={() => setOpenStatusChangeModal(false)}
//             title={"Change Driver Status"}
//             message={
//               <>
//                 Are you sure you want to change the status of driver:{" "}
//                 <strong>{selectedDriver?.full_name}</strong> to{" "}
//                 <strong>
//                   {selectedDriver?.status === 1 ? "Inactive" : "Active"}
//                 </strong>
//                 ?
//               </>
//             }
//             selectedDriver={selectedDriver}
//             onConfirm={handleStatusChange}
//             actionLoadingText="Changing..."
//             ActionBtnText="Change Status"
//             loading={actionLoading}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// }

// *********************************************************************************************


import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Typography, Grid } from "@mui/material";

import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
import AddUserIcon from "../../../../Assets/Icons/add-user-icon.png";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import httpclient from "../../../../Utils";
import { createFilterHandler } from "../../../../Utils/FilterUtils";
import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
import { useBranch } from "../../../../Hooks/useBranch";
import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

import { getColumns } from "./columns";
import Filter from "./Filter";
import ConfirmationModal from "./ConfirmationModal";
import DriverDetailsModal from "./DriverDetailsModal";

const INITIAL_FILTER_STATE = {
  driverName: "",
  active: "",
  branch: null,
  userName: "",
};

const fieldMappings = {
  driverName: ["full_name", "$contains"],
  active: ["status", "$eq"],
  branch: ["branch", "$contains"],
  userName: ["user_name", "$contains"],
};

const valueTransformers = {
  active: (value) => {
    if (value === "Active") return 1;
    if (value === "Inactive") return 0;
    return value;
  },
  branch: (value) => {
    if (typeof value === "object") {
      return value?.branch_code || value;
    }
    return value;
  },
};

export default function DriversTable() {
  const navigate = useNavigate();

  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
  const [submittedData, setSubmittedData] = useState({});
  const [openDeleteDriver, setOpenDeleteDriver] = useState(false);
  const [openViewDetails, setOpenViewDetails] = useState(false);
  const [selectedDriverForView, setSelectedDriverForView] = useState(null);
  const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
  
  //  states for assign and clear orders
  const [openAssignOrders, setOpenAssignOrders] = useState(false);
  const [openClearOrders, setOpenClearOrders] = useState(false);
  const [selectedDriverForAssignOrders, setSelectedDriverForAssignOrders] = useState(null);
  const [selectedDriverForClearOrders, setSelectedDriverForClearOrders] = useState(null);
  
  //  states for invoice scan
  const [openInvoiceScanModal, setOpenInvoiceScanModal] = useState(false);
  const [selectedDriverForInvoiceScan, setSelectedDriverForInvoiceScan] = useState(null);
  
  const [allowAdd, setAllowAdd] = useState(1);
  const [allowInvoiceScanFeature, setAllowInvoiceScanFeature] = useState(0); // Add this flag
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [sortModel, setSortModel] = useState([]);
  const [refreshList, setRefreshList] = useState(false);

  const { currentBranch } = useBranch();
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  const fetchDrivers = async () => {
    setLoading(true);

    const endpoint = `delivery/drivers`;

    const apiUrl = buildApiQuery(endpoint, {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      filters: submittedData,
      sortModel,
      fieldMappings,
      valueTransformers,
    });

    try {
      const res = await httpclient.get(apiUrl);
      const { data } = res;
      console.log("response check", res);
      if (data.status === 200) {
        setDrivers(data.data);
        setRowCount(data.meta?.total || data.count || 0);
        if (data.allow_add !== undefined) {
          setAllowAdd(data.allow_add);
        }
        //  invoice scan feature flag
        if (data.allow_invoice_scan_enabled_feature !== undefined) {
          setAllowInvoiceScanFeature(data.allow_invoice_scan_enabled_feature);
        }
        setRefreshList(false);
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDrivers();
  }, [
    refreshList,
    currentBranch,
    paginationModel.page,
    paginationModel.pageSize,
    sortModel,
    submittedData,
  ]);

  const handleChangeFilter = (field) => (event, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value || (event && event.target.value) || "",
    }));
  };

  // Clear Orders handler
  const handleClearOrders = async () => {
    setActionLoading(true);

    const API_URL = `delivery/clear-invoices/${selectedDriverForClearOrders?.id}`;

    try {
      const { data } = await httpclient.post(API_URL);

      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedDriverForClearOrders(null);
        setOpenClearOrders(false);
        setRefreshList(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        showNotification("error", "Driver not found");
        setTimeout(() => {
          setOpenClearOrders(false);
        }, 1000);
      } else if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setActionLoading(false);
    }
  };

  //  Orders handler
  const handleAssignOrders = async () => {
    setActionLoading(true);

    const API_URL = `delivery/drivers/assign-orders/${selectedDriverForAssignOrders?.id}`;

    try {
      const { data } = await httpclient.post(API_URL);

      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedDriverForAssignOrders(null);
        setOpenAssignOrders(false);
        setRefreshList(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        showNotification("error", "Driver not found");
        setTimeout(() => {
          setOpenAssignOrders(false);
        }, 1000);
      } else if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setActionLoading(false);
    }
  };

  // Handle Invoice Scan Change handler
  const handleInvoiceScanChange = async () => {
    setActionLoading(true);
    const API_URL = `delivery/drivers/change-invoice-scan/${selectedDriverForInvoiceScan?.id}`;
    try {
      const { data } = await httpclient.post(API_URL);
      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedDriverForInvoiceScan(null);
        setOpenInvoiceScanModal(false);
        setRefreshList(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        showNotification("error", "Driver not found");
        setTimeout(() => {
          setRefreshList(true);
        }, 1000);
      } else if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleFilter = createFilterHandler({
    setLoading,
    setSubmittedData,
    setResults: setDrivers,
    showNotification,
    handleApiError,
    httpClient: httpclient,
    endpoint: `delivery/drivers`,
    fieldMappings,
    valueTransformers,
    refresh,
  });

  const onFilterClick = () => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    handleFilter(filterData);
  };

  const handleRemove = (field) => {
    const newFilterData = { ...filterData };
    const newSubmittedData = { ...submittedData };

    newFilterData[field] = field === "branch" ? null : "";
    delete newSubmittedData[field];

    setFilterData(newFilterData);
    setSubmittedData(newSubmittedData);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    handleFilter(newFilterData);
  };

  const handleClearFilters = () => {
    setFilterData(INITIAL_FILTER_STATE);
    setSubmittedData({});
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleAddDriver = () => {
    navigate("/delivery/drivers/add");
  };

  const handleEdit = (driver) => {
    setSelectedDriver(driver);
    navigate(`/delivery/drivers/edit/${driver.id}`);
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleDeleteDriver = async () => {
    setActionLoading(true);
    const API_URL = `delivery/drivers/delete/${selectedDriver.id}`;
    try {
      const { data } = await httpclient.post(API_URL);
      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedDriver(null);
        setOpenDeleteDriver(false);
        setRefreshList(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        showNotification("error", "Driver not found");
        setTimeout(() => {
          setRefreshList(true);
        }, 1000);
      } else {
        handleApiError(error);
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleStatusChange = async () => {
    setActionLoading(true);
    const API_URL = `delivery/drivers/change-status/${selectedDriver.id}`;
    try {
      const { data } = await httpclient.post(API_URL);
      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedDriver(null);
        setOpenStatusChangeModal(false);
        setRefreshList(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        showNotification("error", "Driver not found");
        setTimeout(() => {
          setRefreshList(true);
        }, 1000);
      } else {
        handleApiError(error);
      }
    } finally {
      setActionLoading(false);
    }
  };

  const columns = getColumns(
    handleEdit,
    setOpenDeleteDriver,
    setSelectedDriver,
    setOpenViewDetails,
    setSelectedDriverForView,
    setOpenStatusChangeModal,
    setOpenAssignOrders,
    setSelectedDriverForAssignOrders,
    setOpenClearOrders,
    setSelectedDriverForClearOrders,
    () => setRefreshList(true),
    drivers,
    setOpenInvoiceScanModal,
    setSelectedDriverForInvoiceScan,
    allowInvoiceScanFeature 
  );

  const deleteDriverMessage = (
    <>
      Are you sure you want to delete driver:{" "}
      <strong>{selectedDriver?.full_name}</strong>
    </>
  );

  const assignOrdersMessage = (
    <>
      Are you sure you want to assign orders to driver:{" "}
      <strong>{selectedDriverForAssignOrders?.full_name}</strong>?
    </>
  );

  const clearOrdersMessage = (
    <>
      Are you sure you want to release all assigned invoices for driver:{" "}
      <strong>{selectedDriverForClearOrders?.full_name}</strong>?
    </>
  );

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "24px 16px",
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Drivers
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            gap={2}
          >
            {allowAdd === 1 && (
              <Button
                variant="contained"
                sx={{
                  borderRadius: "4px",
                  backgroundColor: "#7152F3",
                  "&:hover": {
                    backgroundColor: "#5c34fa",
                  },
                }}
                startIcon={<img src={AddUserIcon} alt="Add Driver" />}
                onClick={handleAddDriver}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  Add New Driver
                </Typography>
              </Button>
            )}
            <img
              src={filterOpen ? FilterBtnUp : FilterBtn}
              alt="Filter"
              style={{ cursor: "pointer" }}
              onClick={() => setFilterOpen(!filterOpen)}
            />
          </Grid>
          <Filter
            filterOpen={filterOpen}
            filterData={filterData}
            handleChangeFilter={handleChangeFilter}
            handleFilter={onFilterClick}
            handleClearFilters={handleClearFilters}
            handleRemove={handleRemove}
            submittedData={submittedData}
          />
        </Grid>

        <DataGrid
          rows={drivers || []}
          columns={columns}
          autoHeight
          disableRowSelectionOnClick
          initialState={{
            pagination: { paginationModel: { pageSize: 20 } },
          }}
          loading={loading}
          slots={{
            loadingOverlay: CustomLoadingOverlay,
          }}
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: "14px",
              fontWeight: 500,
              color: "#48505E",
            },
          }}
          paginationMode="server"
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          sortModel={sortModel}
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
        />

        {/* Clear Orders Modal */}
        {openClearOrders && (
          <ConfirmationModal
            open={openClearOrders}
            handleClose={() => setOpenClearOrders(false)}
            title={"Clear Invoice"}
            message={clearOrdersMessage}
            selectedDriver={selectedDriverForClearOrders}
            onConfirm={handleClearOrders}
            actionLoadingText="Releasing..."
            ActionBtnText="Release Invoices"
            loading={actionLoading}
          />
        )}

        {/* Assign Orders Modal */}
        {openAssignOrders && (
          <ConfirmationModal
            open={openAssignOrders}
            handleClose={() => setOpenAssignOrders(false)}
            title={"Assign Orders"}
            message={assignOrdersMessage}
            selectedDriver={selectedDriverForAssignOrders}
            onConfirm={handleAssignOrders}
            actionLoadingText="Assigning..."
            ActionBtnText="Assign Orders"
            loading={actionLoading}
          />
        )}

        {/* Delete Driver Modal */}
        {openDeleteDriver && (
          <ConfirmationModal
            open={openDeleteDriver}
            handleClose={() => setOpenDeleteDriver(false)}
            title={"Delete Driver"}
            message={deleteDriverMessage}
            selectedDriver={selectedDriver}
            onConfirm={handleDeleteDriver}
            actionLoadingText="Deleting..."
            ActionBtnText="Delete"
            loading={actionLoading}
          />
        )}

        {/* View Details Modal */}
        {openViewDetails && (
          <DriverDetailsModal
            open={openViewDetails}
            onClose={() => setOpenViewDetails(false)}
            driverId={selectedDriverForView?.id}
          />
        )}

        {/* Change Status Modal */}
        {openStatusChangeModal && (
          <ConfirmationModal
            open={openStatusChangeModal}
            handleClose={() => setOpenStatusChangeModal(false)}
            title={"Change Driver Status"}
            message={
              <>
                Are you sure you want to change the status of driver:{" "}
                <strong>{selectedDriver?.full_name}</strong> to{" "}
                <strong>
                  {selectedDriver?.status === 1 ? "Inactive" : "Active"}
                </strong>
                ?
              </>
            }
            selectedDriver={selectedDriver}
            onConfirm={handleStatusChange}
            actionLoadingText="Changing..."
            ActionBtnText="Change Status"
            loading={actionLoading}
          />
        )}

        {/* Change Invoice Scan Modal */}
        {openInvoiceScanModal && (
          <ConfirmationModal
            open={openInvoiceScanModal}
            handleClose={() => setOpenInvoiceScanModal(false)}
            title={"Change Invoice Scan Status"}
            message={
              <>
                Are you sure you want to change the invoice scan status for driver:{" "}
                <strong>{selectedDriverForInvoiceScan?.full_name}</strong> to{" "}
                <strong>
                  {selectedDriverForInvoiceScan?.is_invoice_scan_enabled === 1 ? "Disabled" : "Enabled"}
                </strong>
                ?
              </>
            }
            selectedDriver={selectedDriverForInvoiceScan}
            onConfirm={handleInvoiceScanChange}
            actionLoadingText="Changing..."
            ActionBtnText="Change Status"
            loading={actionLoading}
          />
        )}
      </Box>
    </Box>
  );
}